import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';

const rules = ({ hideCursor }) => ({
  border: 'none',
  bottom: '0',
  left: '0',
  position: 'absolute',
  right: '0',
  top: '0',
  extend: {
    condition: hideCursor,
    style: {
      cursor: 'none',
    },
  },
});

const PlayerBackground = ({ hideCursor, onClick }) => {
  const { css } = useFela({ hideCursor });

  return (
    <div className={css(rules)} onClick={onClick} />
  );
};

PlayerBackground.propTypes = {
  hideCursor: PropTypes.bool,
  onClick: PropTypes.func,
};

export default React.memo(PlayerBackground);
